<template>
  <v-dialog
    v-model="isDialog" 
    content-class="right-dialog rounded-r-0" 
    transition="slide-x-reverse-transition" 
    max-width="1100"
    scrollable
  >
    <v-card style="height: 100vh;" class="rounded-r-0">
      <v-card-title class="primary white--text d-flex justify-space-between align-center">
        <div>
          <v-btn color="white" icon @click="isDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>{{$t('bill.setting_bill')}}
        </div>
        <v-tooltip bottom color="success" v-if="form.id && mode != 'view'">
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
            >
              <v-switch
                v-model="form.isActive"
                class="mt-0 mb-1"
                hide-details
                :disabled="isSaving"
                :label="$t('bill.use_export_bill')"
                color="white" 
                @change="changeActive($event)"
              >
                <template v-slot:label>
                  <span class="white--text font-weight-bold">{{ $t('bill.use_export_bill') }}</span>
                </template>
              </v-switch>
            </div>
          </template>
          <span>{{ $t('bill.turn_on_or_off_auto_bill_work') }}</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text class="px-6 pt-2" v-if="!isLoading && mode == 'view'">
        <div class="d-flex mt-4">
          <div class="primary--text px-4 py-1 d-flex" style="border: 3px solid var(--v-primary-base); border-radius: 5px">
            <h3 class="mb-0 d-flex"><b>{{ $t('area.space') }} {{ contract.areasText }} {{ $t('contract.title') }} {{ contract.contractId }}</b></h3>
          </div>
        </div>
        <v-alert
          border="left"
          color="success"
          text
          class="my-8 py-4"
          style="font-size: 18px;"
        >
          <div v-if="form.loopType" class="py-2">
            <span>
              {{ $t('bill.export_bill_time_message', { form: loopTypeString[form.loopType], startDate: $moment(form.startDate).format('D MMM YYYY'), endDate: $moment(form.endDate).format('D MMM YYYY') }) }}
              <b class="primary--text">{{ $t('bill.all_of_date', { date: loopData.all.length }) }}</b>
            </span>
          </div>
          <div v-else>{{ $t('bill.you_not_select_export_bill') }}</div>
        </v-alert>
        <v-card elevation="10" :class="`rounded-lg mt-13`">
          <v-card-text class="px-0 py-0">
            <v-simple-table class="border-b-2">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th width="3%" class="text-center">{{ $t('rank') }}</th>
                    <th width="17%">{{ $t('product.product_name') }}</th>
                    <th width="8%">{{ $t('area.space') }}</th>
                    <th width="6%" class="text-right">{{ $t('product.quantity') }}</th>
                    <th width="8%">{{ $t('unit') }}</th>
                    <th width="8%" class="text-right">{{ $t('product.unit_price') }}</th>
                    <th width="8%" class="text-right">{{ $t('product.discount_unit') }}</th>
                    <th width="8%">{{ $t('product.vat') }}</th>
                    <th width="8%">{{ $t('accounting_product.withholding_tax') }}</th>
                    <th width="8%" class="text-right">{{ $t('product.total_price') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.data.items" :key="index">
                    <td class="py-2 px-2 text-center">{{ index + 1 }}</td>
                    <td class="py-2 px-2 vertical-top">
                      <v-autocomplete
                        v-model="item.name" 
                        :placeholder="$t('product.product_name')"
                        :items="accountingProductOptions"
                        item-text="name"
                        item-value="name"
                        outlined 
                        dense 
                        hide-details
                        :rules="[rules.required]"
                        :menu-props="{ closeOnContentClick: true }"
                        disabled
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title>
                              <v-btn text color="green" block link @click="addProduct()">
                                <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('area.add_service_list') }}
                              </v-btn>
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item v-if="item.isAddProduct">
                            <v-list-item-title>
                              <v-btn text color="green" block link @click="addProduct()">
                                <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('area.add_service_list') }}
                              </v-btn>
                            </v-list-item-title>
                          </v-list-item>
                          <template v-else>
                            <v-list-item @click="chooseItem(item, form.data.items[index])"
                              v-show="!item.obj.isRemoved">{{ item.name }}</v-list-item>
                          </template>
                        </template>
                      </v-autocomplete>
                      <v-text-field 
                        v-model="item.detail"
                        :placeholder="$t('detail')"
                        outlined
                        dense
                        hide-details
                        value="detail"
                        disabled
                      />
                    </td>
                    <td class="py-2 vertical-top">
                      <v-select
                        v-model="item.area"
                        :no-data-text="$t('noinfo')"
                        :disabled="item.billingSetting && item.area ? true : false" 
                        :items="[{ isRemove: true, name: '-' }, ...invoiceAreas]"
                        :item-text="(i) => (i.isRemove ? '-' : `${i.name} (${i.size || '-'}${$t('square_meter')})`)"
                        :item-value="(r) => r.isRemove ? { isRemove: true } : { className: 'Area', objectId: r.objectId, __type: 'Pointer', }"
                        outlined 
                        dense
                        hide-details
                        @change="chooseArea(index)" 
                        disabled
                      >
                        <template v-slot:selection="{ item }">
                          <div class="d-block w-100" style="width: 100%">
                            <div text v-if="item.isRemove">-</div>
                            <template v-else>
                              <div class="d-block w-100">{{ item.name }}</div>
                              <div class="d-block w-100 text-right text-gray" style="font-size: 13px">{{ `${item.size || '-'}${$t('square_meter')}` }}</div>
                            </template>
                          </div>
                        </template>
                      </v-select>
                    </td>
                    <td class="py-2 px-2 text-right vertical-top">
                      <v-currency-field :placeholder="$t('quantity')" class="input-right input-disable-appearance" outlined
                        dense hide-details v-model="item.quantity"
                        @input="changeTotalOriginalValue(index, form.data.items)"
                        :rules="[rules.required]" disabled></v-currency-field>
                    </td>
                    <td class="py-2 px-2 vertical-top">
                      <v-text-field v-model="item.unit" :placeholder="$t('unit')" outlined dense hide-details
                      :rules="[rules.required]" disabled></v-text-field>
                    </td>
                    <td class="py-2 px-2 text-right vertical-top">
                      <v-currency-field v-model="item.originalPricePerUnit" :placeholder="$t('product.unit_price')"
                        class="input-right input-disable-appearance" outlined dense hide-details
                        @input="changeTotalOriginalValue(index, form.data.items, true)"
                        :rules="[rules.required]" disabled :options="{ precision: {}}"></v-currency-field>
                    </td>
                    <td class="py-2 px-2 text-right vertical-top">
                      <v-menu v-if="item.type != 'discount'" offset-y style="max-width: 600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-currency-field v-model="item.discountPerUnit" :placeholder="$t('product.discount_per_unit_price')"
                            class="input-right input-disable-appearance" outlined dense hide-details
                            @input="changeTotalOriginalValue(index, form.data.items, true)"
                            :suffix="item.discountType == 2 ? '%' : ''" v-bind="attrs" v-on="on"
                            :rules="item.discountType == 2 ? [rules.maxDiscountPercent] : []" disabled/>
                        </template>
                        <v-card>
                          <v-card-title class="px-3 py-2">
                            <h5 class="my-0">{{ $t('product.select_discount_type') }}</h5>
                          </v-card-title>
                          <v-card-text class="px-4 py-0">
                            <v-radio-group v-model="item.discountType" class="my-0 py-0 small-radio" column
                              @input="changeTotalOriginalValue(index, form.data.items, true)">
                              <v-radio :label="$helper.currencyThEn()" :value="1"></v-radio>
                              <v-radio :label="$t('percent')" :value="2"></v-radio>
                            </v-radio-group>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                      <v-currency-field v-else v-model="item.discountPerUnit" :placeholder="$t('product.discount_per_unit_price')"
                        class="input-right input-disable-appearance" outlined dense hide-details
                        @input="changeTotalOriginalValue(index, form.data.items, true)"
                        :disabled="item.refInvoiceBooking ? true : false" disabled/>
                    </td>
                    <td class="py-2 px-2 text-right vertical-top">
                      <v-select 
                        v-model="item.sellVatType" 
                        :items="[
                          {
                            text: `${$globalVatPercent}%`,
                            value: 1,
                          },
                          {
                            text: '0%',
                            value: 2,
                          },
                          {
                            text: $t('except'),
                            value: 3,
                          },
                        ]" 
                        item-text="text" item-value="value" :placeholder="$t('tax.tax_vat')" outlined dense
                        hide-details disabled :no-data-text="$t('noinfo')"
                      />
                    </td>
                    <td class="py-2 px-2 text-right vertical-top">
                      <v-select v-model="item.whtPercent"
                        :items="taxWithheldOptions"
                        item-text="name" item-value="value" :placeholder="$t('product.withholding')" outlined lang dense
                        hide-details disabled :no-data-text="$t('noinfo')">
                        <template v-slot:selection="data">
                          <div class="d-block w-100" style="width: 100%">
                            <template v-if="data.item.value > 0">
                              <div class="d-block w-100">
                                {{ totalWhtValueIn(item) | currency }}
                                <br />
                              </div>
                            </template>
                            <div class="d-block w-100" :style="data.item.value > 0 ? 'font-size: 13px' : ''"
                              :class="data.item.value > 0 ? 'text-right text-gray' : ''">{{ data.item.name }}
                            </div>
                          </div>
                        </template>
                      </v-select>
                    </td>
                    <td class="py-2 px-2 text-right vertical-top">
                      <v-currency-field v-model="item.totalOriginalValue" :placeholder="$t('product.total_price')"
                        class="input-right input-disable-appearance" outlined dense hide-details
                        @input="changeTotalOriginalValue(index, form.data.items)"
                        :rules="[rules.required]" :prefix="item.type == 'discount' ? '' : ''" disabled />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <div class="mt-15">
          <div class="rounded-lg px-5 py-4" style="border: 2px solid var(--v-primary-base);">
            <v-row no-gutters>
              <v-col cols="3">
                <div class="border-r-2">
                  <div>{{ $t('payment.total_amount') }}</div>
                  <h4 class="primary--text font-weight-bold">{{ totalOriginalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                </div>
              </v-col>
              <v-col cols="3" class="text-center">
                <div class="border-r-2">
                  <div>{{ $t('payment.total_discount_amount') }}</div>
                  <h4 class="primary--text font-weight-bold">{{ totalDiscountValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                </div>
              </v-col>
              <v-col cols="3" class="text-center">
                <div class="border-r-2">
                  <div>{{ $t('tax.tax_vat') }}</div>
                  <h4 class="primary--text font-weight-bold">{{ totalVatValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                </div>
              </v-col>
              <v-col cols="3" class="text-right">
                <div>
                  <div><b>{{ $t('market.total_value') }}</b></div>
                  <h4 class="primary--text font-weight-bold">{{ totalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <hr style="border-top: 1px dashed gray" class="my-8" />
        <h2 class="text-center black--text font-weight-bold">{{ $t('bill.summary_of_auto_bill') }}</h2>
        <div class="mt-10" style="width: 100%;">
          <v-row>
            <v-col cols="5">
              <h3 class="mb-0 black--text"><b>{{ $t('contract.setting_bill_per_day_of_monthly_contract') }}</b></h3>
              <h3>{{ documentTypeString }}</h3>
              <v-alert
                border="left"
                color="success"
                text
                dense
                class="mt-2"
                style="font-size: 18px;"
              >
                <div v-if="form.loopType">
                  <span>
                    {{ $t('bill.export_bill_time_message', { form: loopTypeString[form.loopType], startDate: $moment(form.startDate).format('D MMM YYYY'), endDate: $moment(form.endDate).format('D MMM YYYY') }) }}
                    <b class="primary--text">{{ $t('bill.all_of_date', { date: loopData.all.length }) }}</b>
                  </span>
                </div>
                <div v-else>{{ $t('bill.you_not_select_auto_bill') }}</div>
              </v-alert>
            </v-col>
            <v-col cols="2"></v-col>
            <v-col cols="5">
              <div class="rounded-lg px-5 py-6 box-summary" style="border: 2px solid var(--v-primary-base);">
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_amount') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ totalOriginalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('payment.total_discount_amount_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ totalDiscountValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_exempt_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ totalNonVatItemsValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_calculated_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ totalVatItemsValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic">{{ $t('tax.tax_vat') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number">{{ totalVatValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <hr class="my-4" />
                <v-row>
                  <v-col cols="7" class="py-0">
                    <p class="summary-topic bold">{{ $t('market.total_value') }}</p>
                  </v-col>
                  <v-col cols="5" class="py-0 text-right">
                    <p class="summary-number bold">{{ totalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                  </v-col>
                </v-row>
                <div v-if="true">
                  <hr class="my-4" />
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic">{{ $t('tax.tax_withholding') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number">{{ totalWhtValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="7" class="py-0">
                      <p class="summary-topic bold">{{ $t('payment.total_amount_to_pay') }}</p>
                    </v-col>
                    <v-col cols="5" class="py-0 text-right">
                      <p class="summary-number bold">
                        {{ totalValue(form.data.items) - totalWhtValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}
                      </p>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-8">
          <div 
            class="d-flex justify-space-between align-center py-6" 
            style="background-color: rgba(76, 175, 80, 0.2); border: 2px solid rgba(102, 187, 106, 1); border-radius: 5px;"
          >
            <v-row>
              <v-col cols="4" class="d-flex align-center">
                <div class="black--text font-weight-bold ms-6" style="font-size: 20px;">{{ $t('bill.already_export_bill') }}</div>
              </v-col>
              <v-col cols="4" class="d-flex align-center justify-center">
                <div class="d-flex flex-column align-center">
                  <div class="primary--text font-weight-bold" style="font-size: 20px; display: block;">
                    {{ form.invoices ? form.invoices.length : 0 }}/{{ form.loopDays.length }}
                  </div>
                  <div v-if="form.isActive && nextBill" style="font-size: 16px;" class="mt-1">
                    {{ $t('bill.next_export_bill_message', { form: form.invoices ? form.invoices.length + 1 : 1, loop: form.loopDays.length, date: $moment(nextBill).format("D/MM/YYYY") }) }}
                  </div>
                </div>
              </v-col>
              <v-col cols="4" class="d-flex align-center justify-end">
                <v-btn
                  color="black"
                  icon
                  large
                  class="me-4"
                  @click="isShowInvoices = !isShowInvoices"
                >
                  <v-icon>{{ isShowInvoices ? 'mdi-minus' : 'mdi-plus ' }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <template v-if="isShowInvoices">
            <div class="d-flex justify-space-between align-center mt-6">
              <h3 class="black--text font-weight-bold">{{ $t('bill.bill_list') }}</h3>
              <div>
                <div class="black--text ps-4 pe-10 py-2 rounded" style="border: 1px solid #0000006B;">
                  {{ documentTypeString }}
                </div>
              </div>
            </div>
            <InvoiceContract 
              :isLoading="isLoading || isLoadingInvoice" 
              :invoices="filterInvoicesSchedulerTask"
              @onLoad="onLoadInvoice()"
            ></InvoiceContract>
          </template>
        </div>
      </v-card-text>
      <v-card-text class="px-2 pt-2" v-if="!isLoading && mode != 'view' && isDialog">
        <v-stepper
          v-model="step"
          vertical
          class="elevation-0"
        >
          <v-stepper-step
            :complete="step > 1"
            step="1"
          >
            <h4 class="primary--text">{{ $t('area.step_1') }}</h4>
            <small>{{ $t('bill.setting_export_bill') }}</small>
          </v-stepper-step>
          <v-expand-transition>
            <div v-show="step > 1" style="max-width: 730px; position: absolute; left: 80px;">
              <v-alert
                border="left"
                color="success"
                text
                class="mt-2"
              >
                <div v-if="form.loopType">
                  <span>
                    {{ $t('bill.export_bill_time_message', { form: loopTypeString[form.loopType], startDate: $moment(form.startDate).format('D MMM YYYY'), endDate: $moment(form.endDate).format('D MMM YYYY'), all: loopData.all.length }) }}
                    <b class="primary--text">{{ $t('bill.all_of_date', { date: loopData.all.length }) }}</b>
                  </span>
                </div>
                <div v-else>{{ $t('bill.you_not_select_export_bill_type') }}</div>
              </v-alert>
            </div>
          </v-expand-transition>
          <v-stepper-content step="1" class="pt-0" :style="step > 1 ? 'height: 90px' : ''">
            <v-form ref="formStep1" @submit.prevent="submitStep()">
              <div class="box-step-content" style="max-width: 900px; margin: 0 auto">
                <div class="d-flex">
                  <v-text-field
                    v-model="form.name"
                    :label="$t('setting_name')"
                    outlined
                    dense
                    style="flex: 60%;"
                    class="me-1"
                    :rules="[rules.required]"
                  />
                  <v-select
                    v-model="form.data.documentType"
                    :items="documentTypeOptions"
                    item-text="text"
                    item-value="value"
                    :label="$t('bill.select_bill')"
                    outlined
                    dense
                    style="flex: 50%;"
                    class="ms-1"
                    :rules="[rules.required]"
                    :no-data-text="$t('noinfo')"
                  />
                </div>
                <v-card elevation="10" class="rounded-lg">
                  <v-card-text>
                    <SelectLoopDate
                      v-if="isDialog"
                      :startDate.sync="form.startDate"
                      :endDate.sync="form.endDate"
                      :loopType.sync="form.loopType"
                      :loopDays.sync="form.loopDays"
                      :loopDate.sync="form.loopDate"
                      :loopWeekDays.sync="form.loopWeekDays"
                      :loopData.sync="loopData"
                    />
                  </v-card-text>
                </v-card>
              </div>
              <v-btn class="mt-4" color="primary" type="submit">
                {{ $t('next') }}
              </v-btn>
            </v-form>
          </v-stepper-content>

          <v-stepper-step
            :complete="step > 2"
            step="2"
          >
            <h4 :class="step > 1 ? 'primary--text' : ''">{{ $t('area.step_2') }}</h4>
            <small>{{ $t('bill.detail_export_bill') }}</small>
          </v-stepper-step>
          <v-stepper-content step="2" class="pt-0">
            <v-form ref="formStep2" @submit.prevent="submitStep()" v-if="!isLoading">
              <div class="box-step-content" style="width: 100%;">
                <v-row>
                  <v-col cols="3">
                    <div style="padding-top:10px; font-size: 15px">{{ $t('market.due_date_after_bill') }}</div>
                  </v-col>
                  <v-col cols="3">
                    <v-currency-field 
                      :label="$t('duration_day')"
                      v-model="form.data.creditTerm"
                      outlined
                      dense
                      hide-details
                      class="input-disable-appearance"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field 
                      disabled
                      type="text"
                      :value="$moment().format('D/MM/YYYY')"
                      :label="$t('customer.example_of_document_date')"
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-calendar"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      disabled type="text"
                      :value="creditTermEndDate"
                      :label="$t('customer.example_of_due_date')"
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-calendar"
                    />
                  </v-col>
                </v-row>
                <v-card elevation="10" class="rounded-lg mt-5">
                  <v-card-text>
                    <h3 class="primary--text"><b>{{ $t('customer.customer_detail') }}</b></h3>
                    <v-row class="mt-2">
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.data.customerData.name"
                          :rules="[rules.required]"
                          :placeholder="$t('customer.company_name_and_customer_name')"
                          :label="$t('customer.company_name_and_customer_name')"
                          outlined
                          dense
                          hide-details
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          v-model="form.data.customerData.address"
                          :placeholder="$t('address.address_detail')"
                          :label="$t('address.address_detail')"
                          outlined
                          dense
                          hide-details
                          rows="2"
                          no-resize
                        />
                      </v-col>
                      <v-col cols="6" class="d-flex align-end pt-0">
                        <v-text-field
                          v-model="form.data.customerData.branchName"
                          :placeholder="$t('address.company_branch')"
                          :label="$t('address.company_branch')"
                          outlined
                          dense
                        />
                      </v-col>
                      <v-col cols="6" class="pt-0">
                        <EditTaxId 
                          v-model="form.data.customerData.taxId" 
                          :customClassLabel="'d-block mb-3'"
                          :customClassWarning="'mb-2'" 
                          :backgroundColor="'#fff'"
                          showWarning 
                          :showLabel='false'
                          :getIsVat="customerType == 'company' ? true : false"
                          :getIsExport="customerType == 'company' ? true : false" 
                          showPlaceholder
                          :customClassInput="'input-disable-appearance'" 
                          :solo='false' 
                          :flat='false' 
                          outlined 
                          dense
                          :counter='false'
                          @onWriteData="editTaxIdWriteData"
                          @input="form.data.customerData.taxId = $event"
                          :getRules="rules"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.data.customerData.tel"
                          :placeholder="$t('account.phone_number')"
                          :label="$t('account.phone_number')"
                          outlined
                          dense
                          hide-details
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.data.customerData.email"
                          placeholder="Email"
                          label="Email"
                          outlined
                          dense
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <template v-if="$helper.currencyOptions.length > 1">
                  <div class="box-currency-select mt-13">
                    <div class="txt-title">{{ $t('payment.currency') }}:</div>
                    <CurrencySelect 
                      v-model="form.data.currencyCode" 
                    />
                  </div>
                </template>

                <v-card elevation="10" :class="`rounded-lg mt-13 ${isErrorItems ? 'border-error' : '' }`">
                  <v-card-text class="px-0 py-0">
                    <v-simple-table class="border-b-2">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th width="3%" class="text-center">{{ $t('rank') }}</th>
                              <th width="17%">{{ $t('product.product_name') }}</th>
                              <th width="8%">{{ $t('area.space') }}</th>
                              <th width="6%" class="text-right">{{ $t('product.quantity') }}</th>
                              <th width="8%">{{ $t('unit') }}</th>
                              <th width="8%" class="text-right">{{ $t('product.unit_price') }}</th>
                              <th width="8%" class="text-right">{{ $t('product.discount_unit') }}</th>
                              <th width="8%">{{ $t('tax.tax_vat') }}</th>
                              <th width="8%">{{ $t('tax.tax_withholding') }}</th>
                              <th width="8%" class="text-right">{{ $t('product.total_price') }}</th>
                              <th width="3%" class="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in form.data.items" :key="index">
                              <td class="py-2 px-2 text-center">{{ index + 1 }}</td>
                              <td class="py-2 px-2 vertical-top">
                                <v-autocomplete
                                  v-model="item.name" 
                                  :placeholder="$t('product.product_name')"
                                  :items="accountingProductOptions"
                                  item-text="name"
                                  item-value="name"
                                  outlined 
                                  dense 
                                  hide-details
                                  :rules="[rules.required]"
                                  :menu-props="{ closeOnContentClick: true }"
                                  :disabled="isLoadAccountingProduct"
                                  :error="isDuplicateItem(item)"
                                >
                                  <template v-slot:no-data>
                                    <v-list-item v-if="enableAddAccountingProduct">
                                      <v-list-item-title>
                                        <v-btn text color="green" block link @click="addProduct()">
                                          <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('area.add_service_list') }}
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-else class="d-flex justify-center">
                                      {{ $t('bill.no_bill_list') }}
                                    </v-list-item>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <v-list-item v-if="item.isAddProduct">
                                      <v-list-item-title>
                                        <v-btn text color="green" block link @click="addProduct()">
                                          <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('area.add_service_list') }}
                                        </v-btn>
                                      </v-list-item-title>
                                    </v-list-item>

                                    <template v-else>
                                      <v-list-item @click="chooseItem(item, index)"
                                        v-show="!item.obj.isRemoved">{{ item.name }}</v-list-item>
                                    </template>
                                  </template>
                                </v-autocomplete>
                                <v-text-field 
                                  v-model="item.detail"
                                  :placeholder="$t('detail')"
                                  outlined
                                  dense
                                  hide-details
                                  value="detail"
                                />
                                <template v-if="isDuplicateItem(item)">
                                  <p class="mb-1"><small class="red--text">{{ $t('area.have_bill_and_stall') }}</small></p>
                                </template>
                              </td>
                              <td class="py-2 vertical-top">
                                <v-select
                                  v-model="item.area"
                                  :no-data-text="$t('noinfo')"
                                  :disabled="item.billingSetting && item.area ? true : false" 
                                  :items="[{ isRemove: true, name: '-' }, ...invoiceAreas]"
                                  :item-text="(i) => (i.isRemove ? '-' : `${i.name} (${i.size || '-'}${$t('square_meter')})`)"
                                  :item-value="(r) => r.isRemove ? { isRemove: true } : { className: 'Area', objectId: r.objectId, __type: 'Pointer', }"
                                  outlined 
                                  dense
                                  hide-details
                                  @change="chooseArea(index)" 
                                  :error="isDuplicateItem(item)"
                                >
                                  <template v-slot:selection="{ item }">
                                    <div class="d-block w-100" style="width: 100%">
                                      <div text v-if="item.isRemove">-</div>
                                      <template v-else>
                                        <div class="d-block w-100">{{ item.name }}</div>
                                        <div class="d-block w-100 text-right text-gray" style="font-size: 13px">{{ `${item.size || '-'}${$t('square_meter')}` }}</div>
                                      </template>
                                    </div>
                                  </template>
                                </v-select>
                              </td>
                              <td class="py-2 px-2 text-right vertical-top">
                                <v-currency-field :placeholder="$t('product.quantity')" class="input-right input-disable-appearance" outlined
                                  dense hide-details v-model="item.quantity"
                                  @input="changeTotalOriginalValue(index, form.data.items)"
                                  :rules="[rules.required]" />
                              </td>
                              <td class="py-2 px-2 vertical-top">
                                <v-text-field v-model="item.unit" :placeholder="$t('unit')" outlined dense hide-details
                                :rules="[rules.required]"></v-text-field>
                              </td>
                              <td class="py-2 px-2 text-right vertical-top">
                                <v-currency-field v-model="item.originalPricePerUnit" :placeholder="$t('product.unit_price')"
                                  class="input-right input-disable-appearance" outlined dense hide-details
                                  @input="changeTotalOriginalValue(index, form.data.items, true)" :options="{ precision: {}}"
                                  :rules="item.type == 'discount' ? [] : [rules.required]" :disabled="item.type == 'discount'" />
                              </td>
                              <td class="py-2 px-2 text-right vertical-top">
                                <v-menu v-if="item.type != 'discount'" offset-y style="max-width: 600px">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-currency-field v-model="item.discountPerUnit" :placeholder="$t('product.discount_per_unit_price')"
                                      class="input-right input-disable-appearance" outlined dense hide-details
                                      @input="changeTotalOriginalValue(index, form.data.items, true)"
                                      :suffix="item.discountType == 2 ? '%' : ''" v-bind="attrs" v-on="on"
                                      :rules="item.discountType == 2 ? [rules.maxDiscountPercent] : []" />
                                  </template>
                                  <v-card>
                                    <v-card-title class="px-3 py-2">
                                      <h5 class="my-0">{{ $t('product.select_discount_type') }}</h5>
                                    </v-card-title>
                                    <v-card-text class="px-4 py-0">
                                      <v-radio-group v-model="item.discountType" class="my-0 py-0 small-radio" column
                                        @input="changeTotalOriginalValue(index, form.data.items, true)">
                                        <v-radio :label="$helper.currencyThEn()" :value="1"></v-radio>
                                        <v-radio :label="`${$globalVatPercent}%`" :value="2"></v-radio>
                                      </v-radio-group>
                                    </v-card-text>
                                  </v-card>
                                </v-menu>
                                <v-currency-field v-else v-model="item.discountPerUnit" :placeholder="$t('product.discount_per_unit_price')"
                                  class="input-right input-disable-appearance" outlined dense hide-details
                                  @input="changeTotalOriginalValue(index, form.data.items, true)"
                                  :disabled="item.refInvoiceBooking ? true : false" />
                              </td>
                              <td class="py-2 px-2 text-right vertical-top">
                                <v-select 
                                  v-model="item.sellVatType" 
                                  :items="[
                                    {
                                      text: `${$globalVatPercent}%`,
                                      value: 1,
                                    },
                                    {
                                      text: '0%',
                                      value: 2,
                                    },
                                    {
                                      text: $t('except'),
                                      value: 3,
                                    },
                                  ]" 
                                  item-text="text" item-value="value" :placeholder="$t('tax.tax_vat')" outlined dense
                                  hide-details
                                  :no-data-text="$t('noinfo')"
                                />
                              </td>
                              <td class="py-2 px-2 text-right vertical-top">
                                <v-select v-model="item.whtPercent"
                                  :items="taxWithheldOptions"
                                  item-text="name" item-value="value" :placeholder="$t('product.withholding')" outlined lang dense
                                  hide-details :no-data-text="$t('noinfo')">
                                  <template v-slot:selection="data">
                                    <div class="d-block w-100" style="width: 100%">
                                      <template v-if="data.item.value > 0">
                                        <div class="d-block w-100">
                                          {{ totalWhtValueIn(item) | currency }}
                                          <br />
                                        </div>
                                      </template>
                                      <div class="d-block w-100" :style="data.item.value > 0 ? 'font-size: 13px' : ''"
                                        :class="data.item.value > 0 ? 'text-right text-gray' : ''">{{ data.item.name }}
                                      </div>
                                    </div>
                                  </template>
                                </v-select>
                              </td>
                              <td class="py-2 px-2 text-right vertical-top">
                                <v-currency-field v-model="item.totalOriginalValue" :placeholder="$t('product.total_price')"
                                  class="input-right input-disable-appearance" outlined dense hide-details
                                  @input="changeTotalOriginalValue(index, form.data.items)"
                                  :rules="[rules.required]" :prefix="item.type == 'discount' ? '' : ''" />
                              </td>
                              <td class="text-center">
                                <v-icon class="mr-2"
                                  @click="deleteItem(form.data.items, index)">mdi-trash-can-outline</v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    <v-card-actions>
                      <v-btn
                        color="info"
                        @click="addItem()"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        {{ $t('area.add_row') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
                <div class="mt-15">
                  <div class="rounded-lg px-5 py-4" style="border: 2px solid var(--v-primary-base);">
                    <v-row no-gutters>
                      <v-col cols="3">
                        <div class="border-r-2">
                          <div>{{ $t('payment.total_amount') }}</div>
                          <h4 class="primary--text font-weight-bold">{{ totalOriginalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                        </div>
                      </v-col>
                      <v-col cols="3" class="text-center">
                        <div class="border-r-2">
                          <div>{{ $t('payment.total_discount_amount') }}</div>
                          <h4 class="primary--text font-weight-bold">{{ totalDiscountValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                        </div>
                      </v-col>
                      <v-col cols="3" class="text-center">
                        <div class="border-r-2">
                          <div>{{ $t('tax.tax_vat') }}</div>
                          <h4 class="primary--text font-weight-bold">{{ totalVatValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                        </div>
                      </v-col>
                      <v-col cols="3" class="text-right">
                        <div>
                          <div><b>{{ $t('market.total_value') }}</b></div>
                          <h4 class="primary--text font-weight-bold">{{ totalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</h4>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
              <v-btn class="mt-2" color="primary" type="submit">
                {{ $t('next') }}
              </v-btn>
              <v-btn class="mt-2" text color="default" @click="step = 1">
                {{ $t('back') }}
              </v-btn>
            </v-form>
          </v-stepper-content>

          <v-stepper-step
            :complete="step > 3"
            step="3"
          >
            <h4 :class="step > 1 ? 'primary--text' : ''">{{ $t('bill.summary_export_bill') }}</h4>
            <small>{{ $t('bill.summary_of_auto_bill') }}</small>
          </v-stepper-step>
          <v-stepper-content step="3" class="pt-0">
            <div class="box-step-content" style="width: 100%;">
              <v-row>
                <v-col cols="5">
                  <v-alert
                    color="success"
                    text
                    dense
                    class="mb-2"
                  >
                    <h4 class="mb-0"><b>{{ $t('area.space') }} {{ contract.areasText }} {{ $t('contract.title') }} {{ contract.contractId }}</b></h4>
                  </v-alert>
                  <h3 class="mb-0 black--text"><b>{{ $t('contract.setting_bill_per_day_of_monthly_contract') }}</b></h3>
                  <h3>{{ documentTypeString }}</h3>
                  <v-alert
                    border="left"
                    color="success"
                    text
                    dense
                    class="mt-2"
                    style="font-size: 18px;"
                  >
                    <div v-if="form.loopType">
                      <span>
                        {{ $t('bill.export_bill_time_message', { form: loopTypeString[form.loopType], startDate: $moment(form.startDate).format('D MMM YYYY'), endDate: $moment(form.endDate).format('D MMM YYYY') }) }}
                        <b class="primary--text">{{ $t('bill.all_of_date', { date: loopData.all.length }) }}</b>
                      </span>
                    </div>
                    <div v-else>{{ $t('bill.you_not_select_export_bill_type') }}</div>
                  </v-alert>
                </v-col>
                <v-col cols="2"></v-col>
                <v-col cols="5">
                  <div class="rounded-lg px-5 py-6 box-summary" style="border: 2px solid var(--v-primary-base);">
                    <v-row>
                      <v-col cols="7" class="py-0">
                        <p class="summary-topic">{{ $t('payment.total_amount') }}</p>
                      </v-col>
                      <v-col cols="5" class="py-0 text-right">
                        <p class="summary-number">{{ totalOriginalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                      </v-col>
                    </v-row>
                    <hr class="my-4" />
                    <v-row>
                      <v-col cols="7" class="py-0">
                        <p class="summary-topic">{{ $t('payment.total_discount_amount_value') }}</p>
                      </v-col>
                      <v-col cols="5" class="py-0 text-right">
                        <p class="summary-number">{{ totalDiscountValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="py-0">
                        <p class="summary-topic">{{ $t('tax.tax_exempt_value') }}</p>
                      </v-col>
                      <v-col cols="5" class="py-0 text-right">
                        <p class="summary-number">{{ totalNonVatItemsValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="py-0">
                        <p class="summary-topic">{{ $t('tax.tax_calculated_value') }}</p>
                      </v-col>
                      <v-col cols="5" class="py-0 text-right">
                        <p class="summary-number">{{ totalVatItemsValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7" class="py-0">
                        <p class="summary-topic">{{ $t('tax.tax_vat') }}</p>
                      </v-col>
                      <v-col cols="5" class="py-0 text-right">
                        <p class="summary-number">{{ totalVatValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                      </v-col>
                    </v-row>
                    <hr class="my-4" />
                    <v-row>
                      <v-col cols="7" class="py-0">
                        <p class="summary-topic bold">{{ $t('market.total_value') }}</p>
                      </v-col>
                      <v-col cols="5" class="py-0 text-right">
                        <p class="summary-number bold">{{ totalValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                      </v-col>
                    </v-row>
                    <div v-if="true">
                      <hr class="my-4" />
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic">{{ $t('tax.tax_withholding') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number">{{ totalWhtValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}</p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="7" class="py-0">
                          <p class="summary-topic bold">{{ $t('payment.total_amount_to_pay') }}</p>
                        </v-col>
                        <v-col cols="5" class="py-0 text-right">
                          <p class="summary-number bold">
                            {{ totalValue(form.data.items) - totalWhtValue(form.data.items) | currencySuffixTextThEn(form.data.currencyCode) }}
                          </p>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-btn class="mt-2" color="primary" @click="save()" :disabled="isSaving || isLoading" :loading="isSaving">
              {{ $t('save') }}
            </v-btn>
            <v-btn class="mt-2" text color="default" @click="step = 2" :disabled="isSaving || isLoading">
              {{ $t('back') }}
            </v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
      <v-card-text style="height: 100%" class="px-2 pt-2 d-flex align-center justify-center" v-if="isLoading">
        <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
      </v-card-text>
    </v-card>
    <AccountingProductManageDialog 
      v-model="isDialogAccountingProduct" 
      :projectId="projectId"
      @onSaveSuccess="loadAccountingProducts()"
    />
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import Helper from "../plugins/Helper/Helper";
import EditTaxId from "../components/EditTaxId.vue";
import InvoiceContract from "../components/InvoiceContract.vue";
import SelectLoopDate from "../components/SelectLoopDate.vue";
import AccountingProductManageDialog from "../components/AccountingProductManageDialog.component.vue";
import { AccountingProduct, AreaAccountingProduct, Market } from "../classes"
import CurrencySelect from "@/components/CurrencySelect.vue";
export default {
  props: {
    value: Boolean,
    schedulerTaskId: String,
    contract: Object,
    marketId: String,
    projectId: String,
    mode: String
  },
  components: {
    EditTaxId,
    InvoiceContract,
    SelectLoopDate,
    AccountingProductManageDialog,
    CurrencySelect
  },
  data() {
    return {
      project: null,
      market: null,
      isLoading: false,
      isLoadAccountingProduct: false,
      isLoadingInvoice: false,
      isLoadingCreditTerm: false,
      isSaving: false,
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        requiredQuantity: value => !!value || value == 0 || this.$t('validate.please_input_data'),
        texId: value => value.length == 0 || value.length == 13 || this.$t('validate.please_input_data_correct_thirteen_digit'),
        maxDiscountPercent: v => v <= 100 || this.$t('validate.please_max_percent'),
        numbersOnly: value => !value || /^\d+$/.test(value) || this.$t('validate.numbers_only'),
      },
      step: 1,
      form: {
        id: null,
        contractId: null,
        name: "",
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
        loopType: null,
        loopDays: [],
        loopWeekDays: [],
        loopDate: null,
        type: "invoice",
        isActive: false,
        data: {
          currencyCode : this.$globalCurrencyCode || 'THB',
          customerData: {},
          documentType: null,
          isVatInclusive: true,
          items: [],
          creditTerm: 7
        }        
      },
      documentTypeOptions: [
        { text: this.$t('bill.monthly_rent_bill'), value: 1 },
        { text: this.$t('bill.daily_bill'), value: 7 },
        // { text: "บิลค่าประกัน", value: 2 },
        // { text: "บิลค่าแรกเข้า", value: 3 },
        // { text: "บิลย้ายออก", value: 4 },
        { text: this.$t('bill.other_bill'), value: 5 },
        // { text: "บิลผ่อนผัน", value: 6 },
      ],
      taxWithheldOptions: [
        {
          name: this.$t('no'),
          value: 0
        },
        {
          name: "0.75%",
          value: 0.75
        },
        {
          name: "1%",
          value: 1
        },
        {
          name: "1.5%",
          value: 1.5
        },
        {
          name: "2%",
          value: 2
        },
        {
          name: "3%",
          value: 3
        },
        {
          name: "5%",
          value: 5
        },
        {
          name: "10%",
          value: 10
        },
        {
          name: "15%",
          value: 15
        }
      ],
      invoiceAreas: [],
      loopData: {
        all: []
      },
      weekDays: this.$moment.weekdays().map((d, i) => {
        return {
          text: d,
          value: i,
          isSelect: false
        }
      }),
      customerType: "personal",
      isShowInvoices: false, 
      invoicesSchedulerTask: [],
      accountingProducts: [],
      areaAccountingProducts: [],
      loopTypeString: {},
      invoiceType: 0,
      invoiceTypeOptions: [],
      isDialogAccountingProduct: false,
    }
  },
  watch: {
    isDialog() {
      this.step = 1
      this.initData()
    },
  },
  created() {
    this.loopTypeString.everyday = this.$t('everyday'),
    this.loopTypeString.everyweek = this.$t('everyweek'),
    this.loopTypeString.everymonth = this.$t('everymonth'),
    this.loopTypeString.manual = this.$t('custom'),

    this.invoiceTypeOptions = [
        {
          text: this.$t('all'),
          value: 0
        },
        {
          text: this.$t('bill.monthly_rent_bill'),
          value: 1
        },
        {
          text: this.$t('bill.checkin_bill'),
          value: 3
        },
        {
          text: this.$t('bill.other_bill'),
          value: 5
        },
    ];
  },
  computed:{
    ...mapState({
      schedulerTask: state => state.schedulerTask.schedulerTask,
    }),
    ...mapGetters({
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
    }),
    isDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    enableAddAccountingProduct(){
      if (this.admin || this.employee && this.employee.enableAddAccountingProduct) {
        return true
      }
    },
    accountingProductOptions() {
      let _accountingProducts = this.accountingProducts?.map(d => {
        return {
          isAddProduct: false,
          name: `${d.name}`,
          objectId: d.objectId,
          obj: d
        };
      }) || []
      if (this.enableAddAccountingProduct) _accountingProducts.push({ isAddProduct: true })
      return _accountingProducts
    },
    isErrorItems() {
      return this.form.data.items.length == 0
    },
    monthDays(){
      return new Array(31).fill(0).map((_, i) => i + 1)
    },
    maxStartDate(){
      if(this.$moment(this.form.startDate) > this.$moment()){
        return this.$moment().format("YYYY-MM-DD")
      }else{
        return this.$moment(this.form.startDate).format("YYYY-MM-DD")
      }
    },
    filterInvoicesSchedulerTask(){
      if (this.invoiceType) {
        return this.invoicesSchedulerTask.filter(d => d.documentType == this.invoiceType)
      } else {
        return this.invoicesSchedulerTask
      }
    },
    nextBill(){
      let successDays = this.form.successDays || []
      let loopDays = this.form.loopDays || []
      let unSuccessDays = loopDays.filter(d => !successDays.includes(d) && this.$moment(d).isSameOrAfter(this.$moment()))[0]
      return unSuccessDays
    },
    creditTermEndDate(){
      return this.$moment().add(this.form.data.creditTerm, 'days').format('D/MM/YYYY')
    },
    documentTypeString(){
      if (this.form.data.documentType && this.documentTypeOptions.find(d => d.value == this.form.data.documentType)) {
        return this.documentTypeOptions.find(d => d.value == this.form.data.documentType).text
      } else {
        return ""
      }
    }
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
    this.initData()
  },
  methods: {
    async loadAccountingProducts() {
      this.isLoadAccountingProduct = true
      try {
        let [accountingProducts, areaAccountingProducts] = await Promise.all([
          AccountingProduct.getAccountingProducts({
            projectId: this.projectId
          }),
          AreaAccountingProduct.getAreaAccountingProductByAreas(
            this.invoiceAreas.map(d => d.objectId)
          )
        ])
        this.accountingProducts = accountingProducts
        this.areaAccountingProducts = areaAccountingProducts
        this.isLoadAccountingProduct = false
      }catch (error) {
        this.isLoadAccountingProduct = false
        throw error
      }
    },
    async loadInvoices() {
      this.isLoadingInvoice = true
      try {
        this.invoicesSchedulerTask = await this.$store.dispatch("invoice/getInvoicesBySchedulerTask",{
          schedulerTaskId: this.schedulerTaskId
        })
        this.isLoadingInvoice = false
      }catch (error) {
        this.isLoadingInvoice = false
        throw error
      }
    },
    async initCreditTerm() {
      this.isLoadingCreditTerm = true
      try {
        if(this.contract.creditTerm){
          this.form.data.creditTerm = this.contract.creditTerm
        } else {
          let market = await Market.getMarket(this.marketId)
          this.form.data.creditTerm = market.creditTerm || 7
        }
        this.isLoadingCreditTerm = false
      } catch (error) {
        this.isLoadingCreditTerm = false
        throw error
      }
    },
    onLoadInvoice(){
      this.loadInvoices()
      this.$emit("onUpdateInvoice")
    },
    async initData(){
      this.isLoading = true
      try {
        this.clearForm()
        if (this.schedulerTaskId) {
          if (this.mode == "view") this.loadInvoices()
          await this.$store.dispatch("schedulerTask/getSchedulerTask", this.schedulerTaskId)
        } else {
          this.$store.commit("schedulerTask/setSchedulerTask", null)
        }
        this.invoiceAreas = [];
        let temps = [
          ...(this.contract ? this.contract.areas : []),
          ...(this.invoice ? this.form.data.items.map(d => d.area) : [])
        ];
        for (let area of temps) {
          if (
            area &&
            this.invoiceAreas.findIndex(d => d.objectId == area.objectId) == -1
          ) {
            this.invoiceAreas.push(area);
          }
        }
        this.invoiceAreas = this.invoiceAreas.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        if (this.schedulerTask) {
          this.form.id = this.schedulerTask.objectId
          this.form.contractId = this.schedulerTask.contract.objectId
          this.form.name = this.schedulerTask.name
          this.form.startDate = this.$moment(this.schedulerTask.startDate.iso).format("YYYY-MM-DD")
          this.form.endDate = this.$moment(this.schedulerTask.endDate.iso).format("YYYY-MM-DD")
          this.form.loopType = this.schedulerTask.loopType
          this.form.loopDays = this.schedulerTask.loopDays
          this.form.loopDate = this.schedulerTask.loopDate
          this.form.loopWeekDays = this.schedulerTask.loopWeekDays
          this.form.type = this.schedulerTask.type
          this.form.isActive = this.schedulerTask.isActive
          this.form.data = {
            ...this.form.data,
            ...JSON.parse(JSON.stringify(this.schedulerTask.data))
          }
          this.form.data.currencyCode = this.schedulerTask.data.currencyCode || "THB"
          this.form.invoices = this.schedulerTask.invoices || []
          this.form.successDays = this.schedulerTask.successDays
          this.form.data.items = this.schedulerTask.data.items.map(d => {
            return {
              ...d,
              name: d.accountingProduct?.name,
              area: d.area && d.area.objectId ? { className: 'Area', objectId: d.area.objectId, __type: 'Pointer', } : { isRemove: true, name: '-' },
              accountingProduct: { className: 'AccountingProduct', objectId: d.accountingProduct.objectId, __type: 'Pointer', },
            }
          })
          if (this.form.loopWeekDays?.length) {
            for(let day of this.weekDays) day.isSelect = this.form.loopWeekDays.indexOf(day.value) != -1
          }

          this.loopData = { all: [] }
          for (let date of this.form.loopDays) {
            if (!this.loopData[`${this.$moment(date).format("YYYY-MM")}`]) this.loopData[`${this.$moment(date).format("YYYY-MM")}`] = []
            this.loopData[`${this.$moment(date).format("YYYY-MM")}`].push(date)
            this.loopData.all.push(date)
          }
          if (this.schedulerTask.contract) {
            let contract = this.schedulerTask.contract
            if(contract.customer){
              this.customerType = contract.customer.type == "company" ? "company" : "personal"
            }
          }
          if (!this.form.data.creditTerm) this.initCreditTerm()
        } else {
          if(this.contract){
            this.form.data.customerData = JSON.parse(JSON.stringify(this.contract.billingData))
            this.form.contractId = this.contract.objectId
            if(this.contract.customer){
              this.customerType = this.contract.customer.type == "company" ? "company" : "personal"
            }
          }
          this.form.data.isVatInclusive = this.project.isVatInclusive
          this.initCreditTerm()
        }
        this.isLoading = false
        this.loadAccountingProducts()
      } catch(err) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
        this.isLoading = false
      }
    },
    clearForm(){
      if (this.$refs.formStep1) this.$refs.formStep1.resetValidation();
      if (this.$refs.formStep2) this.$refs.formStep2.resetValidation();
      this.loopData = { all: [] }
      this.isShowInvoices = false
      this.form = {
        id: null,
        contractId: null,
        name: "",
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
        loopType: null,
        loopDays: [],
        loopDate: null,
        loopWeekDays: [],
        type: "invoice",
        isActive: false,
        data: {
          currencyCode : this.$globalCurrencyCode || 'THB',
          customerData: {},
          documentType: null,
          isVatInclusive: false,
          items: [],
          creditTerm: 7
        },
      }
      this.weekdays = this.$moment.weekdays().map((d, i) => {
        return {
          text: d,
          value: i,
          isSelect: false
        }
      })
      this.addItem()
    },
    submitStep() {
      if (this.$refs[`formStep${this.step}`] && this.$refs[`formStep${this.step}`].validate()) {
        if (this.step == 1 && this.loopData.all.length == 0) {
          this.$toast.show({
            content: this.$t('validate.please_select_date_to_export_auto_bill'),
            color: "error"
          })
          return false
        }
        if (this.step == 2 && (this.isErrorItems || this.form.data.items.find(d => this.isDuplicateItem(d)))) {
          return false
        }
        this.step += 1;
      }else{
        this.$toast.show({
          content: this.$t('validate.please_input_full_data'),
          color: "error"
        })
      }
    },
    editTaxIdWriteData(dataTax) {
      if (this.customerType == 'company' && dataTax) {
        this.form.data.customerData.name = dataTax.companyName
        this.form.data.customerData.address = dataTax.fullAddress
      }
    },
    addItem() {
      this.form.data.items.push({
        name: "",
        area: { isRemove: true, name: '-' },
        unit: "",
        sellVatType: 1,
        accountingProduct: undefined,
        accountingProductId: "",
        whtPercent: 0,
        originalPricePerUnit: 0,
        quantity: 1,
        totalOriginalValue: 0,
        discountType: 1,
        discountPerUnit: 0
      });
    },
    chooseItem(product, index) {
      let accountingProduct = product.obj;
      let item = this.form.data.items[index];
      item.name = accountingProduct.name;
      item.unit = accountingProduct.unit;
      item.sellVatType = accountingProduct.sellVatType;
      item.accountingProduct = {
        className: "AccountingProduct",
        objectId: accountingProduct.objectId,
        __type: "Pointer",
      };
      item.accountingProductId = accountingProduct.objectId;
      item.whtPercent = this.customerType == "company" && !this.market.disableWht ? accountingProduct.whtPercent || 0 : 0;
      item.type = accountingProduct.type;
      item.originalPricePerUnit = 0;
      item.quantity = 1;
      item.totalOriginalValue = 0;
      item.discountType = 1;
      item.discountPerUnit = 0;

      if (!item.area?.isRemove) {
        let area = item.area;
        let areaAccountingProduct = this.areaAccountingProducts.find(
          d =>
            d.area.objectId == area.objectId &&
            d.accountingProduct.objectId == product.objectId
        );
        if (areaAccountingProduct) {
          item.originalPricePerUnit = areaAccountingProduct.cost || 0;
          item.discountPerUnit = areaAccountingProduct.discount || 0;
          item.discountType = areaAccountingProduct.discountType || 0;
          this.changeTotalOriginalValue(index, this.form.data.items, true);
        }
      }
    },
    chooseArea(index) {
      let item = this.form.data.items[index];
      if (
        item.accountingProduct &&
        !item.area?.isRemove &&
        !item.refInvoiceBooking
      ) {
        
        let area = item.area;
        let accountingProduct = item.accountingProduct;

        let areaAccountingProduct = this.areaAccountingProducts.find(
          d =>
            d.area.objectId == area.objectId &&
            d.accountingProduct.objectId == accountingProduct.objectId
        );
        if (areaAccountingProduct) {
          item.originalPricePerUnit = areaAccountingProduct.cost || 0;
          item.discountPerUnit = areaAccountingProduct.discount || 0;
          item.discountType = areaAccountingProduct.discountType || 0;
          this.changeTotalOriginalValue(index, this.form.data.items, true);
        }
      }
    },
    isDuplicateItem(item) {
      if (item.accountingProduct && item.area) {
        return this.form.data.items
          .filter(d =>
            d.accountingProduct?.objectId == item.accountingProduct?.objectId &&
            d.area?.objectId == item.area?.objectId &&
            d.billingSetting?.objectId == item.billingSetting?.objectId
          )
          .length > 1
      }
    },
    preparePostData(){
      let postData = {};
      postData.id = this.form.id
      postData.marketId = this.marketId
      postData.projectId = this.projectId
      postData.contractId = this.form.contractId
      postData.name = this.form.name
      postData.startDate = this.$moment(this.form.startDate).startOf("day").toDate()
      postData.endDate = this.$moment(this.form.endDate).endOf("day").toDate()
      postData.loopType = this.form.loopType
      postData.loopDays = this.loopData.all
      postData.loopDate = this.form.loopDate
      if (this.form.loopType == "everyweek") {
        postData.loopWeekDays = this.form.loopWeekDays
      }
      postData.type = this.form.type
      postData.data = {
        currencyCode: this.form.data.currencyCode,
        customerData: this.form.data.customerData,
        documentType: this.form.data.documentType,
        isVatInclusive: this.form.data.isVatInclusive,
        items: this.form.data.items.map(d => {
          let obj = {};
          if (d.area && !d.area.isRemove) {
            obj.area = d.area
          }
          obj.accountingProduct = d.accountingProduct;
          obj.name = d.name;
          obj.unit = d.unit;
          obj.sellVatType = d.sellVatType;
          obj.whtPercent = d.whtPercent;
          obj.originalPricePerUnit = d.originalPricePerUnit;
          obj.quantity = d.quantity;
          obj.totalOriginalValue = d.totalOriginalValue;
          obj.discountType = d.discountType;
          obj.discountPerUnit = d.discountPerUnit;
          obj.type = d.type;
          obj.detail = d.detail;
          return obj;
        }),
        totalValue: this.totalValue(this.form.data.items),
        totalVatValue: this.totalVatValue(this.form.data.items),
        totalNonVatValue: this.totalNonVatValue(this.form.data.items),
        totalVatItemsValue: this.totalVatItemsValue(this.form.data.items),
        totalNonVatItemsValue: this.totalNonVatItemsValue(this.form.data.items),
        totalWhtValue: this.totalWhtValue(this.form.data.items),
        totalDiscountValue: this.totalDiscountValue(this.form.data.items),
        creditTerm: parseInt(this.form.data.creditTerm),
      }
      return postData
    },
    async save(){
      this.isLoading = true
      this.isSaving = true
      try {
        let postData = this.preparePostData()
        let schedulerTask
        if (postData.id) {
          schedulerTask = await this.$store.dispatch('schedulerTask/updateSchedulerTask', postData)
        }else{
          schedulerTask = await this.$store.dispatch('schedulerTask/createSchedulerTask', postData)
          let dayString = this.$moment().format("YYYY-MM-DD");
          if (schedulerTask.loopDays.find(d => d == dayString)) {
            await this.$store.dispatch('schedulerTask/activeSchedulerTask', {
              id: schedulerTask.objectId,
              dayString: dayString
            })
            this.$emit('onActiveSchedulerTask', schedulerTask)
          }
        }
        this.isLoading = false
        this.isSaving = false
        this.$toast.show({
          content: this.$t('save_success'),
          color: "success"
        })
        this.$emit('onSaveSuccess', schedulerTask)
        this.$emit('input', false)
      } catch (error) {
        this.isLoading = false
        this.isSaving = 
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async changeActive(event){
      this.isSaving = true
      try{
        let schedulerTask = await this.$store.dispatch("schedulerTask/updateSchedulerTask", {
          id: this.form.id,
          isActive: event,
        })
        this.isSaving = false
        this.$toast.show({
          content: this.$t('save_success'),
          color: "success"
        })
        this.$emit('onSaveSuccess', schedulerTask)
      }catch(err){
        this.isSaving = false
        this.$toast.show({
          content: err.message,
          color: "error"
        })
      }
    },
    addProduct() {
      this.isDialogAccountingProduct = true;
    },
    changeTotalOriginalValue(indexItem, items, isOriginalPricePerUnitChange = false) {
      if (items && items[indexItem]) {
        items[indexItem].quantity = parseFloat(items[indexItem].quantity);
        items[indexItem].originalPricePerUnit = parseFloat(items[indexItem].originalPricePerUnit);
        items[indexItem].totalOriginalValue = parseFloat(items[indexItem].totalOriginalValue);
        items[indexItem].discountPerUnit = parseFloat(items[indexItem].discountPerUnit);

        let originalPricePerUnit = 0

        if (!isOriginalPricePerUnitChange) {
          originalPricePerUnit = items[indexItem].totalOriginalValue / items[indexItem].quantity
        } else {
          originalPricePerUnit = items[indexItem].originalPricePerUnit
        }

        let originalDiscountPerUnit = this.originalDiscountPerUnit(items[indexItem])

        if (items[indexItem].type == "discount") {
          if (!isOriginalPricePerUnitChange) {
            items[indexItem].discountPerUnit = (items[indexItem].totalOriginalValue / items[indexItem].quantity) * -1
          } else {
            items[indexItem].totalOriginalValue = ((originalPricePerUnit - items[indexItem].discountPerUnit) * items[indexItem].quantity)
          }
        } else {
          if (!isOriginalPricePerUnitChange) {
            items[indexItem].originalPricePerUnit = (items[indexItem].totalOriginalValue / items[indexItem].quantity) + originalDiscountPerUnit
          } else {
            items[indexItem].totalOriginalValue = (items[indexItem].originalPricePerUnit * items[indexItem].quantity) - (originalDiscountPerUnit * items[indexItem].quantity)
          }
        }
      }
    },
    mergeItems(datas) {
      let res = [];
      for (const data of datas) {
        if (data.items && data.items.length) res = [...data.items, ...res];
      }
      return res;
    },
    deleteItem(items, index) {
      items.splice(index, 1);
    },
    isWht(items) {
      return items.filter(d => d.whtPercent > 0).length > 0;
    },
    totalValueIn(item) {
      let total = 0;
      if (this.form.data.isVatInclusive) {
        total = (item.originalPricePerUnit - this.originalDiscountPerUnit(item)) * item.quantity
      } else {
        total = item.totalOriginalValue + this.totalVatValueIn(item);
      }
      return Helper.round(total);
    },
    totalVatValueIn(item) {
      let vat = 0;
      if (item.sellVatType == 1) {
        if (this.form.data.isVatInclusive) {
          vat = (this.totalValueIn(item) * this.$globalVatPercent) / (100 + this.$globalVatPercent) || 0;
        } else {
          vat = ((item.totalOriginalValue * this.$globalVatPercent) / 100) || 0;
        }
      }
      return Helper.round(vat);
    },
    totalNonVatValueIn(item) {
      return Helper.round(this.totalValueIn(item) - this.totalVatValueIn(item));
    },
    totalWhtValueIn(item) {
      if (item.whtPercent > 0) {
        return Helper.round(
          this.totalNonVatValueIn(item) * (item.whtPercent / 100)
        );
      } else {
        return 0;
      }
    },
    totalOriginalValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0)
      );
    },
    totalVatValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalVatValueIn(b) || 0), 0)
      );
    },
    totalValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalValueIn(b) || 0), 0)
      );
    },
    totalNonVatValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalNonVatValueIn(b) || 0), 0)
      );
    },
    totalVatItemsValue(items) {
      return Helper.round(
        items
          .filter(d => {
            return d.sellVatType == 1;
          })
          .reduce((a, b) => a + (this.totalNonVatValueIn(b) || 0), 0)
      );
    },
    totalNonVatItemsValue(items) {
      return Helper.round(
        items
          .filter(d => {
            return d.sellVatType != 1;
          })
          .reduce((a, b) => a + (this.totalNonVatValueIn(b) || 0), 0)
      );
    },
    totalWhtValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.totalWhtValueIn(b) || 0), 0)
      );
    },
    originalDiscountPerUnit(item) {
      let originalDiscountPerUnit = 0
      if (item.discountType == 1) {
        originalDiscountPerUnit = item.discountPerUnit || 0
      } else {
        originalDiscountPerUnit = (item.originalPricePerUnit * (item.discountPerUnit || 0) / 100)
      }
      return originalDiscountPerUnit
    },
    discountValue(item) {
      if (this.form.data.isVatInclusive) {
        return Helper.round(this.originalDiscountPerUnit(item) * item.quantity)
      } else {
        return Helper.round((this.originalDiscountPerUnit(item) * item.quantity) + this.discountVatValue(item))
      }
    },
    discountVatValue(item) {
      let vat = 0
      if (item.sellVatType == 1 && item.type == "discount") {
        if (this.form.data.isVatInclusive) {
          vat = (this.discountValue(item) * this.$globalVatPercent) / (100 + this.$globalVatPercent) || 0
        } else {
          vat = (this.originalDiscountPerUnit(item) * this.$globalVatPercent / 100) * item.quantity || 0
        }
      }
      return Helper.round(vat)
    },
    totalDiscountValue(items) {
      return Helper.round(
        items.reduce((a, b) => a + (this.discountValue(b) || 0), 0)
      )
    },
  }
};
</script>
<style lang="scss" scoped>
.box-summary {
  box-shadow: 0 0 20px #29c76d5e;
}
.summary-topic {
  margin: 5px 0;
  font-weight: 400;

  &.bold {
    font-weight: 600;
    color: var(--v-primary-base);
    font-size: 16px;
  }
}

.summary-number {
  margin: 5px 0;
  font-weight: 500;

  &.bold {
    font-weight: 700;
    color: var(--v-primary-base);
    font-size: 16px;
  }
}
.box-step-content {
  // max-width: 730px;
  padding: 20px 20px;
  // border: 1px solid black;
}
.border-error{
  border: 2px solid var(--v-error-base);
}
.vertical-top {
  vertical-align: top !important;
}

.box-currency-select {  
  max-width: 300px;
  white-space: nowrap;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .txt-title{
    font-size: 14px;
    font-weight: 700;
    color: #666666;
    margin-right: 50px;
  }

  .icon-currency{
    border-radius: 50%;
    margin-top: 3px;
  }

  .icon-currency-avatar{
    height: 20px !important;
    min-width: 20px !important;
    width: 20px !important;
    margin-right: 5px !important;
  }
}
</style>